  <!-- Footer -->
  <div class="footer"
  [ngStyle]="footerStyles">
    <span>
        <strong>Copyright © 2017 </strong>
        <a class="no-underline text-blue-600 font-bold" href="https://www.serialmultivision.com/"
        target="_blank">Serial Multivision Pte Ltd.</a> All rights reserved.
    </span>
    <span class="environment">
        <span class="fa fa-circle text-green-500" style="font-size:12px"></span> <span style="margin-left: 5px;">{{environmentName}}</span>
    </span>
  </div>
